import * as React from "react";
import styles from "./EnergyLabel.module.scss";
import {useState} from "react";
import Modal from "../lib/ModalWindow/Modal";

type EnergyLabelProps = {
  energyClass: string;
  media?: string;
  size?: "big" | "small";
};

const EnergyLabel: React.FC<EnergyLabelProps> = ({energyClass, media, size = "big"}) => {
  const [open, setOpen] = useState(false);

  return (
    <span
      className={`${styles.wrapper} ${styles[size]}`}
      onClick={(e) => {
        e.preventDefault();
        setOpen(true);
      }}
    >
      <SVGEnergyLabel letter={energyClass} color={energyClassByColor[energyClass]} size={size} />

      {!!media && (
        <Modal
          isVisible={open}
          closeFunction={() => {
            setOpen(false);
          }}
        >
          <div className={styles.imageWrapper}>
            <img alt={energyClass} src={media} />
          </div>
        </Modal>
      )}
    </span>
  );
};

const SVGEnergyLabel: React.FC<{color: string; letter: string; size: "big" | "small"}> = ({
  color,
  letter,
  size = "small",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 93.29 61.39"
      width={size === "small" ? "32px" : "42px"}
      height={size === "small" ? "21px" : "28px"}
    >
      <defs>
        <style>
          {
            ".cls-2,.cls-5{fill:#1d1d1b;}.cls-3,.cls-4{fill:#fff;}.cls-4{font-size:48px;font-family:Calibri-Bold, Calibri;font-weight:700;}.cls-5{font-size:23px;font-family:Calibri;}.cls-6{fill:none;stroke:#1d1d1b;stroke-linecap:round;stroke-miterlimit:7.76;stroke-width:1.5px;}"
          }
        </style>
      </defs>
      <g>
        <g>
          <polygon fill={color} points="0.25 57.99 0.37 0.78 67.94 0.8 92.96 29.4 67.94 57.99 0.25 57.99" />
          <path
            className="cls-2"
            d="M.62,1l67.2,0L92.63,29.4,67.82,57.74H.5L.62,1M.12.53V1L0,57.74v.5H68.05l.15-.17L93,29.73l.29-.33L93,29.07,68.2.72,68.05.55h-.23L.62.53Z"
          />
          <rect className="cls-3" x="0.5" y="1.05" width="21.26" height="56.69" />
          <text className="cls-4" transform="translate(34 43)">
            {letter}
          </text>
          <text className="cls-5" transform="translate(4.04 18.77)">
            A
          </text>
          <text className="cls-5" transform="translate(4.04 54.2)">
            G
          </text>
          <path className="cls-6" d="M6.71,26.77l4.35-4.35a0,0,0,0,1,.07,0l4.4,4.41" />
          <line className="cls-6" x1="11.13" y1="22.94" x2="11.13" y2="34.41" />
        </g>
      </g>
    </svg>
  );
};

export default EnergyLabel;

// Connox GmbH\Shop - Dokumente\Corporate_Design\Icons\09_Energielabel
const energyClassByColor: {[key: string]: string} = {
  A: "#009640",
  B: "#52ae32",
  C: "#c8d400",
  D: "#ffed00",
  E: "#fbba00",
  F: "#ec6608",
  G: "#e30613",
};
